// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'PUT',
    endpoint: '/api/ricarica/badge/:id',
    requestBody: '{dipendenteId,descrizione,validoDal,validoAl,attivo}',
    response: '{success:true}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/badge',
    requestBody: '{societaId,dipendenteId,codice,descrizione,validoDal,validoAl}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/badge?societaId&q&stato',
    requestBody: null,
    response: '{success:true,data:[{id,codice,descrizione,dipendente:{id,nome,cognome},validoDal,validoAl,attivo,ultimoUtilizzoAt}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/badge/sconosciuti',
    requestBody: null,
    response: '{success:true,data:[{codiceBadge,tentativi,ultimoTentativoAt,colonnina:{id,nome,sede,societaNome}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/dipendenti?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome,cognome}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
